var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconClose = function SvgIconClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.071 3.757A2 2 0 0 0 12.243.93L8 5.172 3.757.929A2 2 0 0 0 .93 3.757L5.172 8 .929 12.243a2 2 0 1 0 2.828 2.828L8 10.83l4.243 4.242a2 2 0 1 0 2.828-2.828L10.828 8l4.243-4.243Z",
    fill: "#2E3586"
  })));
};
export default SvgIconClose;